const MobileConst = {
    CLASS_PREFIX: "kv-design-m",
    LOG_PREFIX: "[KV Design]",
    CLEAR_STORAGE_FLAG_KEY: "CLEAR_STORAGE_FLAG_KEY",
};
export default MobileConst;
